/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Delete_GuideInputs */



/**
* | output |
* | --- |
* | "Delete Guide" |
*
* @param {Knp_Guide_Delete_GuideInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_delete_guide = /** @type {((inputs?: Knp_Guide_Delete_GuideInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Delete_GuideInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le guide")
	if (locale === "de") return /** @type {LocalizedString} */ ("Löschanleitung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina Guida")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Руководство по удалению")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guía de eliminación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除指南")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ガイドを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डिलीट गाइड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Guia de Exclusão")
	return /** @type {LocalizedString} */ ("Delete Guide")
});